import { useQuery } from 'convex/react';
import type { FunctionReturnType } from 'convex/server';
import { api } from '@aeon-karaoke/cloud-convex';
import type { Id } from '@aeon-karaoke/cloud-convex/_generated/dataModel';
import { useCurrentUser } from './useCurrentUser';

export type PackShelf = FunctionReturnType<typeof api.packs.list>;
export type PackCard = PackShelf['inPlan'][number];
export type PackDetail = FunctionReturnType<typeof api.packs.get>;

/** The Library shelf, split by the caller's plan server-side. Skips until the
 * users row exists (sign-in bootstrap window). */
export function usePackShelf() {
  const { user } = useCurrentUser();
  return useQuery(api.packs.list, user ? {} : 'skip');
}

/** One pack with its song table, scoped to `search` when it is not blank. */
export function usePack(packId: Id<'packs'> | undefined, search = '') {
  const { user } = useCurrentUser();
  return useQuery(api.packs.get, user && packId ? { packId, search: search.trim() || undefined } : 'skip');
}
